import React, { useState } from "react";
// import axios from "axios";
import venueImage from "../../asset/images/versity_img12.jpg";
import { FiMapPin } from "react-icons/fi";
import "./VenuDetails.css";

const VenueDetails = () => {
  // Static venue details - commented out API calls
  const staticVenueDetails = [
    {
      _id: "venue-1",
      title: "Jashore University of Science and Technology (JUST)",
      description: `Jashore University of Science and Technology (Bengali: যশোর বিজ্ঞান ও প্রযুক্তি বিশ্ববিদ্যালয়), commonly known and abbreviated as JUST (Bengali: যবিপ্রবি), is a government-financed public university in Bangladesh. It is the fourth public university in Khulna Division and the first public university in Jessore. It was established in 2007 and started four-year undergraduate courses from the 2009–2010 session. The university has 29 departments are organised into 8 faculties. JUST has two campuses, one is located in the Jashore district and the other one is located at Jhenidah district. The conference will be held in Jashore campus. The campus is 10.0km away from Palbari bus stop, Jashore city. Visitors can take buses which run toward Chowgacha from the Palbari stop to come to the conference venue. They can also use local transport including rickshaw, bike, car to come to the venue.`,
      imageUrl: venueImage
    }
  ];

  const [venueDetails] = useState(staticVenueDetails);
  // const [loading, setLoading] = useState(true);
  // const [error, setError] = useState(null);

  // Commented out API call - using static venue details
  // useEffect(() => {
  //   const fetchVenueDetails = async () => {
  //     try {
  //       const response = await axios.get(
  //         `${process.env.REACT_APP_BACKEND_SERVER_URL}/api/v1/admin/venues`
  //       );
  //       setVenueDetails(response.data || []);
  //       setLoading(false);
  //     } catch (error) {
  //       console.error("Error fetching venue details:", error);
  //       setError("Error loading venue information");
  //       setLoading(false);
  //     }
  //   };

  //   fetchVenueDetails();
  // }, []);

  return (
    <div className="venue-container">
      <div className="heading-container">
        <h4>Venue Details</h4>
      </div>

      <div className="venue-content">
        {venueDetails.length > 0 ? (
          venueDetails.map((venue) => (
            <div key={venue._id} className="venue-layout">
              {/* Left Side - Image and Map */}
              <div className="venue-left-section">
                {venue.imageUrl && (
                  <div className="venue-image-wrapper">
                    <img
                      src={venue.imageUrl}
                      alt={venue.title}
                      className="venue-image"
                    />
                  </div>
                )}
                
                <div className="venue-map-wrapper">
                  <div className="map-header">
                    <FiMapPin className="map-icon" />
                    <h5>Location Map</h5>
                  </div>
                  <div className="map-container">
                    <iframe 
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3666.2652054975706!2d89.12284257519475!3d23.233434479026585!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39ff1857827d6cb7%3A0xecab69d917b1a29b!2sJashore%20University%20of%20Science%20and%20Technology!5e0!3m2!1sen!2sbd!4v1766258129145!5m2!1sen!2sbd" 
                      width="100%" 
                      height="100%" 
                      style={{border: 0}} 
                      allowFullScreen="" 
                      loading="lazy" 
                      referrerPolicy="no-referrer-when-downgrade"
                      title="JUST Location Map"
                    />
                  </div>
                </div>
              </div>

              {/* Right Side - Details */}
              <div className="venue-right-section">
                <div className="venue-details-card">
                  <h3 className="venue-title">{venue.title}</h3>
                  <div className="venue-description">
                    <p>{venue.description}</p>
                  </div>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="no-data">No venue details available</div>
        )}
      </div>
    </div>
  );
};

export default VenueDetails;